<template>
    <div class="mainVis">

        <img src="../assets/img_kv_bg3.jpg?102938" alt="" class="mainVis_bg">
        <div class="mainVis_in">
            <p class="mainVis_txt">
                <img src="../assets/img_kv_txt4.png?102938"
                    srcset="../assets/img_kv_txt4.png?102938 1x, ../assets/img_kv_txt4@2x.png?102938 2x"
                    alt="MAZEDOLL 鋼鉄の外殻。それは自由へと導く人類の方舟――。">

            </p>
            <div class="mainVis_form">
                <div class="mainVis_formIn">
                    <input type="text" class="mainVis_input" id="dlCode" value="">
                    <input type="submit" value="submit" class="mainVis_submit" @click="submit">
                </div>
                <p class="mainVis_error" id="msg">Download codeは2019.10.27から有効です</p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        methods: {
            submit() {
                var dlc = document.getElementById('dlCode').value;
                let params = new URLSearchParams();
                var info;
                var msgElm = document.getElementById('msg');
                params.append('pass', dlc);
                axios.post('/ACAL-0010/dl.php', params).then(response => {
                        info = response.data;
                     
                        if (info['df'] != '') {
                            location.href = info['df'];

                        }
                        if (info['message'] != '') {
                            msgElm.innerHTML = info['message'];

                        }
                    })
                    .catch();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .mainVis {
        max-height: 1080px;
        position: relative;
        // background:#fff url(../assets/img_kv_bg3.jpg) center center no-repeat;
        background-size: cover;
        overflow: hidden;

        @include mq(xxl) {
            max-height: 1080px;
        }

        @include mq() {
            background-size: 800px;
            background-position: center bottom;
            max-height: 450px;
        }

        @include mq(sm) {
            background-size: 580px;
            max-height: 326px;
            background-position: center bottom;
        }

        &_form {

            margin-top: 10%;

            @include mq() {
                margin-top: 5%;
            }

        }

        &_formIn {
            display: flex;
            justify-content: center;
        }

        &_input {
            border: solid 1px rgba(255, 255, 255, .3);
            padding: 12px 16px;
            width: 400px;
            height: 50px;
            box-sizing: border-box;
            color: #fff;
            font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif !important;

            input:focus {
                outline: none;
            }

            @include mq(lg) {
                width: auto;
            }

            @include mq() {

                padding: 8px 12px;
                height: 30px;
            }

        }

        &_submit {
            border: solid 1px rgba(255, 255, 255, .3);
            padding: 12px 16px;
            color: #fff;
            border-left: 0;
            font-size: 18px;
            line-height: 1;
            height: 50px;
            box-sizing: border-box;
            text-transform: uppercase;
            font-family: "DIN Next LT W01 Bold", "Avenir", Helvetica, Arial, sans-serif;

            input:focus {
                outline: none;
            }

            @include mq() {
                padding: 8px 12px;
                font-size: 11px;
                height: 30px;
            }
        }

        &_error {
            font-size: 14px;
            color: #fff;
            margin-top: 4px;
            text-align: center;

            @include mq() {
                font-size: 12px;
            }
        }

        &_in {
            max-width: 1920px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);

            @include mq(lg) {
                max-width: 100%;

                img {
                    max-width: 100%;
                    box-sizing: border-box;
                }
            }

            @include mq() {
                width: 80%;
                top: 50%;
                left: 50%;
                transform: translate3d(-50%, -40%, 0);

            }

        }

        &_bg {
            width: 100%;
        }
    }
</style>